module.exports = __webpack_public_path__ + "static/media/allergies@2x.3aaf3716.png";